// mediaTagging/tagDomCheck.js — does what the boxes SHOW match what the store will SEND? (plan
// bugfix_2026-10-06_permission-tagging, phase fehler-sichtbar F3). Pure: the DOM texts and the store lookup come in.
//
// Measurement only: a mismatch is reported, nothing is corrected. Since stage 1b the open input is read into the
// store before every immediate send, so a mismatch should no longer happen — this check finds out whether it does.

export const DomMismatch = Object.freeze({
    TEXT_DIFFERS:   'text-differs',     // the box shows other keywords than the store holds
    NOT_IN_STORE:   'not-in-store',     // the box is in the DOM, the store does not know its id (its text is dropped)
});

// Keywords as the server compares them: split at commas, trimmed, empty ones and repeats dropped. Empty string = no keyword.
export function keywordKey(text) {
    return [...new Set(String(text ?? '').split(',').map((k) => k.trim()).filter(Boolean))].join(',');
}

// domBoxes: [{ tagId, text }] as the boxes show them; getStoreTag(id) → model | null.
// Returns [{ tagId, reason, domText, storeText }]. A box without keywords on either side is not compared
// (a freshly drawn box is empty in both).
export function findDomStoreMismatches(domBoxes, getStoreTag) {
    const mismatches = [];
    for (const { tagId, text } of domBoxes) {
        const id = Number(tagId);
        const stored = getStoreTag(id);
        if (!stored) {
            if (keywordKey(text)) { mismatches.push({ tagId: id, reason: DomMismatch.NOT_IN_STORE, domText: text, storeText: null }); }
            continue;
        }
        if (keywordKey(text) !== keywordKey(stored.text)) {
            mismatches.push({ tagId: id, reason: DomMismatch.TEXT_DIFFERS, domText: text, storeText: stored.text ?? '' });
        }
    }
    return mismatches;
}
